import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import styles from './PostingInfo.scss';// to import local scss fle

class PostingInfo extends Component {
  static propTypes = {
    posting: PropTypes.shape().isRequired,
  };
  constructor(props) {
    super(props);
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.state = {
      open: false,
      title: '',
      url: '',
    };
  }

  onOpenModal() {
    this.setState({ open: true });
  }

  onCloseModal() {
    this.setState({ open: false });
  }

  handleChange = (name, value) => {
    this.setState({ ...this.state, [name]: value.target.value });
  };

  render() {
    const modalStyle = {
      width: '100%',
      padding: '0',
    };
    const { open } = this.state;
    const { posting } = this.props;
    const requirements = posting.get('requirements');
    return (
      <div>
        <button onClick={this.onOpenModal} className={styles.infoButton} >
          <img src="https://media.dev.myrecruitboard.com/Images/postingInfo.png" alt="info" />
        </button>
        <Modal modalStyle={modalStyle} open={open} onClose={this.onCloseModal} little>
          <div className={cn('row')}>
            <div className={cn('col s12', styles.removePadding)}>
              <div className={cn('col s12', styles.videoHeader)}>
                <span>ABOUT POSTING</span>
              </div>
              <div className={cn('col s12')}>
                <div className={cn('col s4')}>
                  <span className={styles.mainHeader}>COLLEGE NAME</span><br />
                  <span className={styles.lightText}>
                    {posting.get('college_name')}</span><br /><br />
                </div>
                <div className={cn('col s4')}>
                  <span className={styles.mainHeader}>POSTING TITLE</span><br />
                  <span className={styles.lightText}>
                    {posting.get('posting_title')}
                  </span><br />
                </div>
                <div className={cn('col s12')}>
                  <span className={styles.mainHeader}>DESCRIPTION</span><br />
                  <span className={styles.lightText}>
                    {posting.get('description')}
                  </span><br /><br />
                </div>
                <div className={cn('col s12')}>
                  <span className={styles.mainHeader}>REQUIREMENTS</span><br />
                  <span className={styles.lightText}>
                     Gpa: {requirements.get('min_gpa')},&nbsp;&nbsp;&nbsp;&nbsp;
                    Height: {requirements.get('min_height')},&nbsp;&nbsp;&nbsp;
                    Weight: {requirements.get('min_weight')}&nbsp;&nbsp;&nbsp;
                    40-Yard Dash: {requirements.get('min_t40')}&nbsp;&nbsp;&nbsp;
                    Bench: {requirements.get('min_bench')}&nbsp;&nbsp;&nbsp;
                    Squats: {requirements.get('min_squats')} &nbsp;&nbsp;&nbsp;
                  </span><br /><br /><br />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default PostingInfo;



// WEBPACK FOOTER //
// ./src/components/PostingInfo/PostingInfo.js